function defineValue(target, key, value) {
  Object.defineProperty(target, key, {
    value,
    writable: true,
    configurable: true,
  })
}

if (!Object.values) {
  defineValue(Object, 'values', function values(obj) {
    const source = Object(obj)
    return Object.keys(source).map((key) => source[key])
  })
}

if (!Object.entries) {
  defineValue(Object, 'entries', function entries(obj) {
    const source = Object(obj)
    return Object.keys(source).map((key) => [key, source[key]])
  })
}

if (!Array.prototype.at) {
  defineValue(Array.prototype, 'at', function at(index) {
    const length = this.length >>> 0
    let i = Number(index) || 0
    if (i < 0) {
      i += length
    }
    if (i < 0 || i >= length) {
      return undefined
    }
    return this[i]
  })
}

if (!Array.prototype.flatMap) {
  defineValue(Array.prototype, 'flatMap', function flatMap(callback, thisArg) {
    if (typeof callback !== 'function') {
      throw new TypeError('flatMap callback must be a function')
    }

    const result = []
    for (let i = 0; i < this.length; i++) {
      if (!(i in this)) {
        continue
      }

      const mapped = callback.call(thisArg, this[i], i, this)
      if (Array.isArray(mapped)) {
        result.push(...mapped)
      } else {
        result.push(mapped)
      }
    }
    return result
  })
}

if (!Set.prototype.union) {
  defineValue(Set.prototype, 'union', function union(other) {
    const result = new Set(this)
    for (const value of other) {
      result.add(value)
    }
    return result
  })
}

if (!Set.prototype.intersection) {
  defineValue(Set.prototype, 'intersection', function intersection(other) {
    const otherSet = other instanceof Set ? other : new Set(other)
    const result = new Set()
    for (const value of this) {
      if (otherSet.has(value)) {
        result.add(value)
      }
    }
    return result
  })
}

if (!Set.prototype.difference) {
  defineValue(Set.prototype, 'difference', function difference(other) {
    const otherSet = other instanceof Set ? other : new Set(other)
    const result = new Set()
    for (const value of this) {
      if (!otherSet.has(value)) {
        result.add(value)
      }
    }
    return result
  })
}

if (!Set.prototype.symmetricDifference) {
  defineValue(Set.prototype, 'symmetricDifference', function symmetricDifference(other) {
    const result = new Set(this)
    for (const value of other) {
      if (result.has(value)) {
        result.delete(value)
      } else {
        result.add(value)
      }
    }
    return result
  })
}

if (!Set.prototype.isSubsetOf) {
  defineValue(Set.prototype, 'isSubsetOf', function isSubsetOf(other) {
    const otherSet = other instanceof Set ? other : new Set(other)
    for (const value of this) {
      if (!otherSet.has(value)) {
        return false
      }
    }
    return true
  })
}

if (!Set.prototype.isSupersetOf) {
  defineValue(Set.prototype, 'isSupersetOf', function isSupersetOf(other) {
    for (const value of other) {
      if (!this.has(value)) {
        return false
      }
    }
    return true
  })
}

if (!Set.prototype.isDisjointFrom) {
  defineValue(Set.prototype, 'isDisjointFrom', function isDisjointFrom(other) {
    for (const value of other) {
      if (this.has(value)) {
        return false
      }
    }
    return true
  })
}

if (typeof URL !== 'undefined' && typeof URL.canParse !== 'function') {
  defineValue(URL, 'canParse', function canParse(url, base) {
    try {
      if (typeof base === 'undefined') {
        new URL(url)
      } else {
        new URL(url, base)
      }
      return true
    } catch (_error) {
      return false
    }
  })
}
